
export type GetMetricTypes200Item = typeof GetMetricTypes200Item[keyof typeof GetMetricTypes200Item];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMetricTypes200Item = {
  PAYMENT_PROCESSED: 'PAYMENT_PROCESSED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  SUBSCRIPTION_CREATED: 'SUBSCRIPTION_CREATED',
  SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
  USER_LOGIN: 'USER_LOGIN',
  API_REQUEST: 'API_REQUEST',
} as const;
